import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-background via-background to-primary/5">
      <Navigation />
      
      <main className="flex-1 container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-card rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Cookie Policy
          </h1>
          
          <p className="text-sm text-muted-foreground mb-8">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-6 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">What Are Cookies?</h2>
              <p className="text-muted-foreground leading-relaxed">
                Cookies are small text files that are placed on your computer or mobile device when you visit our website. 
                They are widely used to make websites work more efficiently and provide information to website owners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">How We Use Cookies</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                MeetHub uses cookies to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Keep you signed in to your account</li>
                <li>Remember your preferences and settings</li>
                <li>Understand how you use our services</li>
                <li>Improve our platform's performance and functionality</li>
                <li>Ensure security and prevent fraud</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Types of Cookies We Use</h2>
              
              <div className="space-y-4">
                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Essential Cookies</h3>
                  <p className="text-sm text-muted-foreground">
                    These cookies are necessary for the website to function properly. They enable core functionality 
                    such as security, authentication, and session management. These cookies cannot be disabled.
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Performance Cookies</h3>
                  <p className="text-sm text-muted-foreground">
                    These cookies help us understand how visitors interact with our website by collecting and 
                    reporting information anonymously. They help us improve website performance.
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Functional Cookies</h3>
                  <p className="text-sm text-muted-foreground">
                    These cookies enable the website to provide enhanced functionality and personalization, 
                    such as remembering your preferences and choices.
                  </p>
                </div>

                <div className="bg-muted/50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Analytics Cookies</h3>
                  <p className="text-sm text-muted-foreground">
                    We use analytics cookies to collect information about how visitors use our site. 
                    This data helps us improve user experience and understand usage patterns.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Third-Party Cookies</h2>
              <p className="text-muted-foreground leading-relaxed">
                We may use third-party services that set cookies on our behalf to provide analytics and improve 
                our services. These third parties have their own privacy policies and we have no control over 
                their cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Managing Cookies</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                You can control and manage cookies in several ways:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Use our cookie consent banner to customize your cookie preferences</li>
                <li>Configure your browser settings to block or delete cookies</li>
                <li>Use browser extensions to manage cookie preferences</li>
                <li>Opt out of third-party cookies through their respective websites</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-3">
                Please note that blocking certain cookies may impact your experience on our website and 
                limit some functionality.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Cookie Retention</h2>
              <p className="text-muted-foreground leading-relaxed">
                Session cookies are temporary and are deleted when you close your browser. Persistent cookies 
                remain on your device until they expire or you manually delete them. The retention period varies 
                depending on the type and purpose of the cookie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Updates to This Policy</h2>
              <p className="text-muted-foreground leading-relaxed">
                We may update this Cookie Policy from time to time to reflect changes in our practices or 
                legal requirements. We will notify you of any material changes by posting the updated policy 
                on our website with a new "Last updated" date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3 text-primary">Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about our use of cookies, please contact us at:
              </p>
              <div className="mt-3 space-y-1 text-muted-foreground">
                <p>Email: legal@meethub.com</p>
                <p>Address: MeetHub Legal Department</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
